// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloudServerOutlinedSvg from "@fishx/icons-svg/es/asn/PCloudServerOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloudServerOutlined = function PCloudServerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloudServerOutlinedSvg
  }));
};

PCloudServerOutlined.displayName = 'PCloudServerOutlined';
export default React.forwardRef(PCloudServerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloudServerOutlined.js
// module id = 3291
// module chunks = 0